export { StepsController };
window.StepsController = StepsController;
function StepsController(
   guideData,
   stepSwitcher,
   introController,
   fullScreenController,
   conclusionController,
   prepareEmbed,
   zoom
) {
   var template = prepareEmbed(window.embedHbsTemplates('EMBED_V4_STEPS_HBS'));
   var container = $('#stepsContainer');

   // Step -1 is effectively the start screen and can't be returned to.
   var index = -1;

   var autoStart = false;

   container.on('click', '.js-next', showNextStep);
   container.on('click', '.js-prev', showPrevStep);

   if (!App.hideControls) {
      $(document).keydown(function(event) {
         switch (event.which) {
            case 39: // Right arrow key
               showNextStep();
               break;
            case 37: // Left arrow key
               showPrevStep();
               break;
         }
      });
   }

   container.on('click', '.js-fullscreen', function(event) {
      fullScreenController.toggle();
   });

   container.on('click', '.js-operator-fullscreen', function(event) {
      fullScreenController.toggleParentFullscreen();
   });

   function showNextStep() {
      guideData.get().then(function(guide) {
         var guideLength = guide.steps.length;
         if (guide.type !== 'teardown') {
            guideLength++;
         }

         // The reason for this is not obvious. Upon loading, TitleController
         // in embed.v4.title.js sets the data capture session iframe back
         // to the intro page by calling "stepsController.showNext()". This
         // call was causing data capture to not start on the correct page.
         if (!autoStart) {
            showStep(Math.min(index + 1, guideLength));
         } else {
            autoStart = false;
         }

         // Don't prefetch if we've reached the end of the guide.
         if (index + 2 < guideLength) {
            prefetchStep(Math.min(index + 2, guideLength));
         }
      });
   }

   function setAutoStart(v) {
      autoStart = Boolean(v);
   }

   function getAutoStart() {
      return autoStart;
   }

   function showPrevStep() {
      showStep(Math.max(index - 1, 0));
   }

   function showStep(n) {
      return getStepElement(n)
         .then(function(element) {
            stepSwitcher.show(element, n);
            index = n;
         })
         .reportErrors();
   }

   function prefetchStep(n) {
      return getStepElement(n)
         .then(function(element) {
            stepSwitcher.prefetch(element, n);
         })
         .reportErrors();
   }

   function getStepElement(n) {
      // Step 0 == introduction
      if (!n) {
         return introController.getElement();
      }

      return guideData.get().then(constructStep(n));
   }

   function maxStepNumber() {
      return guideData.get().then(function(guide) {
         return guide.steps.length;
      });
   }

   function constructStep(n) {
      return function(guide) {
         var element;
         if (
            n === guide.steps.length + 1 &&
            guide.type !== 'teardown' &&
            guide.conclusion_rendered
         ) {
            element = conclusionController.getElement(guide);
            element.find('.js-next').addClass('disabled');
            return element;
         }

         $('.js-nav-button').removeClass('disabled');

         var step = guide.steps[n - 1];
         step.url = guide.url;
         step.isSingle = true;
         step.isImage = step.media.type === 'image';
         step.isEmbed = step.media.type === 'embed';
         step.hasMedia = !step.isImage || step.media.data.length > 0;
         step.multipleImages = step.isImage ? step.media.data.length > 1 : false;
         step.pageTitle = step.title !== '' ? step.title : _js('Step') + ' ' + step.number;
         step.isOperatorView = App.hideControls;
         element = template(step);

         if (
            n === guide.steps.length &&
            (guide.type === 'teardown' || guide.conclusion_rendered === '')
         ) {
            element.find('.js-next').addClass('disabled');
         }

         if (step.isImage) {
            /**
             * Setup thumbnail hover switching
             */
            var largeImages = element.find('.large > img');
            element.find('.js-thumbnail').mouseenter(function(event) {
               var ndx = $(this).attr('data-index');
               largeImages.hide();
               $(largeImages[ndx]).show();
            });
            largeImages.on('click', zoom);
         } else if (step.isEmbed) {
            var embedEl = element.find('#embed-' + step.stepid)[0];
            embedEl.innerHTML = step.media.data.html;
         } else {
            var videoEl = element.find('#video-' + step.stepid)[0];
            var video = videojs(
               videoEl,
               {
                  loop: true,
               },
               function() {
                  // We do this afterward because if done before, video-js puts
                  // the padding-bottom rule on the video tag *and* its container
                  var v = step.media.data;
                  var ratio = v.width && v.height ? v.height / v.width : 9 / 16;
                  $(video.el()).css({
                     'padding-bottom': Math.min(75, ratio * 100) + '%',
                  });
               }
            );
            videoEl.setAttribute('controls', true);
         }

         if (!fullScreenController.supported()) {
            element.find('.js-fullscreen').hide();
         }
         return element;
      };
   }

   var self = {
      showNext: showNextStep,
      showStep: showStep,
      maxStepNumber: maxStepNumber,
      getAutoStart: getAutoStart,
   };

   if (App.hideControls) {
      // Make this function accessible from outside the iframe.
      window.showStep = showStep;
      window.setAutoStart = setAutoStart;
      window.getAutoStart = getAutoStart;
   }

   return self;
}
